import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar

import 'nprogress/nprogress.css'; // progress bar style

import { getToken } from '@/utils/auth'; // get token from cookie

import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login']; // no redirect whitelist

router.beforeEach(
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(to, from, next) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            NProgress.start(); // set page title

            document.title = getPageTitle(to.meta.title);
            next(); // determine whether the user has logged in
            //   const hasToken = getToken()
            //   if (hasToken) {
            //     if (to.path === '/login') {
            //       // if is logged in, redirect to the home page
            //       next({ path: '/' })
            //       NProgress.done()
            //     } else {
            //       const hasGetUserInfo = store.getters.name
            //       if (hasGetUserInfo) {
            //         next()
            //       } else {
            //         try {
            //           // get user info
            //           await store.dispatch('user/getInfo')
            //           next()
            //         } catch (error) {
            //           // remove token and go to login page to re-login
            //           await store.dispatch('user/resetToken')
            //           Message.error(error || 'Has Error')
            //           next(`/login?redirect=${to.path}`)
            //           NProgress.done()
            //         }
            //       }
            //     }
            //   } else {
            //     /* has no token*/
            //     if (whiteList.indexOf(to.path) !== -1) {
            //       // in the free login whitelist, go directly
            //       next()
            //     } else {
            //       // other pages that do not have permission to access are redirected to the login page.
            //       next(`/login?redirect=${to.path}`)
            //       NProgress.done()
            //     }
            //   }

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});